<div class="advanced-settings">
  <div class="content">
    <div class="tabs-setting">
      <a routerLink="/advanced-settings/preferences" routerLinkActive="active">Preferences</a>
      <a routerLink="/advanced-settings/tags" routerLinkActive="active">Tags</a>
      <a routerLink="/advanced-settings/Seo" routerLinkActive="active">Seo</a>
    </div>
    <!-- <div class="content__title">SEO</div> -->
    <div class="content__box">
      <label class="toggle" for="noIndexProduct">
        <input type="checkbox" name="noIndexProduct" [(ngModel)]="userInfo.noIndexProduct" class="toggle__input" id="noIndexProduct" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z"></path>
              </svg>
            </span>
          </span>
        </span>
        Google Search is <span class="ml-1 text-{{ userInfo.noIndexProduct ? 'success' : 'danger' }}">{{ userInfo.noIndexProduct ? "Enabled" : "Disabled" }}</span>
      </label>
    </div>
    <button class="my-button-3 d-flex m-auto" (click)="saveProfileInfo()"><i class="fa-solid fa-save"></i> Save</button>
  </div>
</div>
